<template>
  <div id="app">
    <component :is="layout">
    </component>
  </div>
</template>

<script>
import Login from '@/views/Login'
import Baseline from '@/views/Baseline'
import API from "@/axios/api";

/*eslint-disable no-unused-vars*/
export default {
  computed: {
    layout() {
      return this.$store.getters.isAuthenticated
        ? this.$route.meta.layout || 'baseline'
        : 'login'
    }
  },
  components: {
    Login,
    Baseline
  },
  methods: {
    changeTitle(title = null) {
      document.title = title || '';
      if (document.title !== '')
        document.title += '. Лицензирование Carbis'
      else
        document.title = 'Лицензирование Carbis'
    }
  },
  created() {
    this.changeTitle();

    API.interceptors.response.use(response => {
      return response;
    }, error => {
      // this.$store.dispatch('logout').then(() => this.$router.push('/login'));
      if (error.response && error.response.data && error.response.data.message) {
        console.log('error message')
        this.$store.dispatch('showSnackbar', {
          color: 'error',
          text: error.response.data.message,
        })
      } else {
        console.log('just error')
        this.$store.dispatch('showSnackbar', {
          color: 'error',
          text: error,
        })
      }
      throw error;
    });
    if (this.$store.getters.isAuthenticated) {
      this.$store.dispatch('resetHeader')
    }
  },
  watch: {
    '$route'(to, from) {
      this.changeTitle(to.meta.title);
    }
  },
}
</script>

<style>
.clickable-row {
  cursor: pointer;
}
</style>
